import { get } from '@core/api/baseApi';

const getTags = async (q?: string): Promise<string[]> => {
  const tags = await get<string[]>(`/tags?q=${q}`);

  return tags.map((t) => t?.toLowerCase());
};

export default getTags;
